import { API_URL } from './../functions/environmentVariables';
import axios, { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';

export const appAxios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  baseURL: API_URL,
  validateStatus: (status) => status <= 500,
});

appAxios.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (err) => Promise.reject(err)
);

appAxios.interceptors.response.use(
  (res: AxiosResponse) => res,
  async (err) => {
    if (err.response?.status === 401) {
      const token = Cookies.get('token');
      if (token) {
        Cookies.remove('token');
      }
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);
